import { render, staticRenderFns } from "./HeadPhotoLabel.vue?vue&type=template&id=144a004f&scoped=true"
import script from "./HeadPhotoLabel.vue?vue&type=script&lang=js"
export * from "./HeadPhotoLabel.vue?vue&type=script&lang=js"
import style0 from "./HeadPhotoLabel.vue?vue&type=style&index=0&id=144a004f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a004f",
  null
  
)

export default component.exports